import { useState, useRef } from 'react';
import { ModalGeneric, Loader } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import ImputationObjectDetail from '../../../UbicationCard/ImputationObjectDetail/ImputationObjectDetail';
import { statusEnum } from '../../../../../../utils/dataStatus';
import MonthlyImputationObject from '../../../../../../components/WorkReports/MonthlyWorkReport/MonthlyImputationObject/MonthlyImputationObject';
import { postImputationObjects } from '../../../../../../services/certificationsMaster';
import { postImputationObjectsMsds } from '../../../../../../services/serviceRequest';
import useToast from '../../../../../../hooks/useToast';

const OiEditModal = ({
  details,
  hideModal,
  showModal,
  permissions,
  isOyM,
  setLoading,
  isMsds,
  fetchData,
  loading
}) => {
  const { setNewToast } = useToast();
  const [hasError, setHasError] = useState(false);
  const [disabledActions, setDisabledActions] = useState(false);

  const disabledEditStateCancelOrFinish =
    details?.estadoEnum === statusEnum.cancelada || details?.estadoEnum === statusEnum.finalizada;

  const form = useRef(null);

  const updateWellsWithModifiedProps2 = (originalWells, copyWells) =>
    originalWells
      ?.filter((originalWell, index) => {
        if (!copyWells?.length) return false;
        const modifiedWell = copyWells[index];
        // const updatedWell = { ...originalWell };

        const isImputationObjectModified =
          originalWell?.imputationObject?.id !== modifiedWell?.imputationObject?.id;
        const isImputationTypeModified =
          originalWell?.imputationType?.id !== modifiedWell?.imputationType?.id;

        return isImputationObjectModified || isImputationTypeModified;
      })
      .map((originalWell, index) => {
        const modifiedWell = copyWells[index];
        const updatedWell = { ...originalWell };

        // Actualizar los valores relevantes que han cambiado
        if (originalWell?.socCode !== modifiedWell?.socCode?.nombre) {
          updatedWell.socCode = modifiedWell?.socCode?.nombre || originalWell.socCode;
        }
        if (originalWell?.logisticCenter !== modifiedWell?.logisticCenter?.nombre) {
          updatedWell.logisticCenter =
            modifiedWell?.logisticCenter?.nombre || originalWell.logisticCenter;
        }

        return updatedWell;
      });

  const updateData = async () => {
    const originalWells = form?.current?.values?.imputationObject?.wells;
    const copyWells = form?.current?.values?.imputationObject?.copyWells;
    const updatedWellsArray = updateWellsWithModifiedProps2(originalWells, copyWells);

    const createBodyPostArray = (wellsArray) =>
      wellsArray.map((well) => ({
        pozoId: details?.isOyM ? null : well.well.id,
        sociedad: well?.socCode,
        centro: well?.logisticCenter?.length > 1 ? String(well?.logisticCenter) : null,
        tipoImputacion: well?.imputationType?.value,
        objetoImputacion: {
          id: well.imputationObject?.id,
          nombre: well.imputationObject?.nombre.split(' ')[0]
        }
      }));

    setLoading(true);
    const bodyPostWellsArray = createBodyPostArray(updatedWellsArray);

    try {
      if (isMsds) {
        await postImputationObjectsMsds(bodyPostWellsArray, details?.id, details?.ubicationId);
      } else {
        await postImputationObjects(bodyPostWellsArray, details?.id);
      }

      setNewToast({
        type: 'SUCCESS',
        message: `Objetos de imputación modificado`
      });
      fetchData();
      setLoading(false);
      hideModal();
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={hideModal}
      primaryAction={updateData}
      primaryActionDisabled={hasError || disabledActions}
      primaryActionLabel="Aceptar"
      secondaryAction={hideModal}
      secondaryActionLabel="Salir"
      show={showModal}
      size="xl"
      title="Detalle del tipo y objeto de imputación"
    >
      {loading && <Loader show={loading} text="CARGANDO ..." />}
      {isMsds ? (
        <MonthlyImputationObject
          canAddWellToImputationObject={!disabledEditStateCancelOrFinish}
          canEditImputationObject
          data={details}
          form={form}
          fromPteAuthorization
          isOyM={details?.isOyM}
          setDisabledActions={setDisabledActions}
          setHasError={setHasError}
          setLoading={setLoading}
        />
      ) : (
        <ImputationObjectDetail
          details={details}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          form={form}
          fromPteAuthorization
          isOyM={isOyM}
          setDisabledActions={setDisabledActions}
          setHasError={setHasError}
          tpyeAndObjectImputationPermissions={permissions}
        />
      )}
    </ModalGeneric>
  );
};

OiEditModal.propTypes = {
  details: PropTypes.shape({
    estadoEnum: PropTypes.oneOf(Object.values(statusEnum)),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isOyM: PropTypes.bool,
    tipoAsignacion: PropTypes.shape({ id: PropTypes.number }),
    ubicationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  permissions: PropTypes.shape({ editObjectImputation: PropTypes.bool, editWells: PropTypes.bool })
    .isRequired,
  isOyM: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
  isMsds: PropTypes.bool,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

OiEditModal.defaultProps = {
  showModal: false,
  isOyM: false,
  isMsds: false,
  loading: false
};
export default OiEditModal;
